module.exports = __webpack_public_path__ + "img/attention.32951a8f.svg";